// =====================
// 1. Open Search Modal
// =====================
const searchInput = document.querySelector(".custom__search__input");

searchInput.addEventListener("click", function () {
  const summaryBtn = this.nextElementSibling?.querySelector("summary");
  
  if (summaryBtn) {
    summaryBtn.click();
    console.log("Modal opened");
  } else {
    console.warn("Summary element not found");
  }
});

// =====================
// 2. Category Item Click → Fill Search
// =====================
const searchCategoryItems = document.querySelectorAll(".custom__search__categories__item");
searchCategoryItems.forEach(function (item) {
  console.log("clicked");
  
  item.addEventListener("click", function () {
    const searchModalInput = document.querySelector("#Search-In-Modal");
    const categoryEl = this.querySelector("p[data-search-input-will]");
    if (!searchModalInput || !categoryEl) {
      console.warn("Search input or category element not found");
      return;
    }
    const categoryValue = categoryEl.getAttribute("data-search-input-will");
    console.log("Category selected:", categoryValue);

    // Step 1: Find the summary button inside details-modal and open it if not already open
    const detailsModal = document.querySelector("details-modal.custom__search__input__wrapper");
    const summaryBtn = detailsModal?.querySelector("summary.modal__toggle");
    const details = detailsModal?.querySelector("details");

    if (summaryBtn && details && !details.open) {
      summaryBtn.click();
    }

    // Step 2: Wait for modal to open, then fill input
    setTimeout(() => {
      // Clear previous value
      searchModalInput.value = "";
      searchModalInput.dispatchEvent(new Event("input", { bubbles: true }));

      // Set new value
      searchModalInput.value = categoryValue;
      searchModalInput.dispatchEvent(new Event("input", { bubbles: true }));
      searchModalInput.dispatchEvent(new Event("change", { bubbles: true }));

      // Focus the input
      searchModalInput.focus();

      // Trigger predictive search by dispatching keyup (Shopify's predictive search listens to keyup)
      searchModalInput.dispatchEvent(
        new KeyboardEvent("keyup", {
          key: categoryValue.slice(-1),
          bubbles: true,
        })
      );
    }, 350);
  });
});